export default "__VITE_ASSET__BvkKfMWX__"